<template>
	<b-modal id="proceed-to-repair-maintenance" :title="title" ok-title="Proceed" ref="modal" @ok="handleOk"
		:cancel-disabled="disableConfirmButtons" :ok-disabled="disableConfirmButtons" :no-close-on-backdrop="true">

		<loading :active.sync="isLoading" loader="spinner" color="#20A8D8" :is-full-page="false" />

		<div>
			Are you sure you want to proceed with the repair of the following assets from classification?
			<div class="my-2">
				<b>{{ this.selMaintenance.repairCount }} {{ this.selMaintenance.assetType }}</b>
			</div>
		</div>
		<div class="message-note mt-2">
			NOTE: You can no longer edit maintenance details once you proceed.
		</div>
	</b-modal>
</template>

<script>
// Utils
import { DateUtil } from '@/utils/dateutil';

// API
import maintenanceApi from '@/api/maintenanceApi';

// Others
import EventBus from '@/shared/event-bus';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _ from 'lodash';

export default {
	name: 'proceed-to-repair-maintenance',
	components: {
		Loading,
	},
	data() {
		return {
			selMaintenance: {},
			isSuperAdmin: this.$store.getters.isSuperAdmin,
			loggedUser: this.$store.getters.loggedUser,
			// Check for loader
			isLoading: false,
		};
	},
	computed: {
		title() {
			return 'Proceed to Repair';
		},
		disableConfirmButtons() {
			return this.isLoading;
		},
	},
	mounted() {
		EventBus.$on('onRepairSelMaintenance', (maintenance) => {
			if (!_.isEmpty(maintenance)) {
				this.selMaintenance = maintenance;
			}
		});
	},
	methods: {
		async handleOk(evt) {
			// Prevent modal from closing
			evt.preventDefault();

			// show loading indicator
			this.isLoading = true;

			// update fields
			this.selMaintenance.dateUpdated = DateUtil.getCurrentTimestamp();
			this.selMaintenance.updatedBy = this.loggedUser.id;
			this.selMaintenance.status = 'In-Repair';

			let maintenanceId = this.selMaintenance.maintenanceId;
			try {
				let { data } = await maintenanceApi.updateMaintenance(
					this.selMaintenance,
					this.loggedUser.id
				);

				if (data.isSuccess) {
					this.$toaster.success(`Maintenance "${maintenanceId}" is ready to be repaired.`);

					this.$store.dispatch('setCurrentMaintenance', data.maintenance);
					if (!this.isSuperAdmin) {
						this.$router.push({ path: '/repair-maintenance' });
					} else {
						this.$router.push({ path: '/admin/admin-repair-maintenance' });
					}
					this.$refs.modal.hide();

				} else {
					this.$toaster.warning(data.message);
				}

			} catch (error) {
				this.$toaster.error(`Error start repairing maintenance "${maintenanceId}". Please try again.`);
			}

			// hide loading indicator
			this.isLoading = false;
		},
	},
	beforeDestroy() {
		EventBus.$off('onRepairSelMaintenance');
	},
};
</script>

<style scoped>
.message-note {
	font-size: 12px;
	color: #f44335;
	font-style: normal;
}
</style>

